import { REGISTRIES, type Registry } from "@kilat/contracts/tld-pricing";
import { m } from "@/lib/paraglide/messages.js";

/** How each registry reads on screen, for the add dialog and the auto-registration select. */
export const REGISTRY_LABELS: Record<Registry, () => string> = {
  pandi: m.tld_pricing_registry_pandi,
  webnic: m.tld_pricing_registry_webnic,
};

/** The items a Select of registries shows. */
export const registryItems = () => REGISTRIES.map((value) => ({ value, label: REGISTRY_LABELS[value]() }));
